module.exports = __webpack_public_path__ + "static/media/illicrmimage.0ad3e2b5.jpg";